"use client";

import React from "react";
import { Check, Clipboard, Heart, PenTool, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  title: "Detaylı Konsültasyon",
  desc: "Kişisel ihtiyaçlarınızın analizi ve beklentilerinizin değerlendirilmesi.",
  icon: Clipboard
}, {
  id: 2,
  title: "Özel Planlama",
  desc: "Size en uygun tedavi rotasının ve tekniklerin belirlenmesi.",
  icon: PenTool
}, {
  id: 3,
  title: "Hassas Uygulama",
  desc: "Uzman ellerde, maksimum konforla gerçekleştirilen güvenli işlem.",
  icon: Sparkles
}, {
  id: 4,
  title: "Hızlı İyileşme",
  desc: "Günlük yaşantınıza en kısa sürede, yenilenmiş olarak dönüş.",
  icon: Heart
}];
const benefits = ["Doğal görünümlü ve kalıcı sonuçlar", "Minimum iyileşme süresi ve yüksek konfor", "Tamamen kişiselleştirilmiş estetik yaklaşım", "Uluslararası standartlarda güvenli uygulama"];
export default function TreatmentDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="treatment-details" className="bg-background py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto bg-secondary rounded-[2.5rem] p-8 md:p-16 lg:p-24 transition-all duration-[800ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
          {}
          <div className="lg:col-span-5 flex flex-col justify-center">
            <h2 className="font-serif text-3xl text-foreground mb-12 tracking-wide">
              Tedavi Süreci
            </h2>
            <div className="relative">
              {}
              <div className="absolute left-[19px] top-4 bottom-4 w-px bg-primary/30" />

              <div className="space-y-12">
                {steps.map((step, i) => {
                const Icon = step.icon;
                return <div key={step.id} data-index={i} className="relative flex items-start gap-6 group">
                      <div className="relative z-10 flex items-center justify-center w-10 h-10 rounded-full bg-secondary border border-primary/40 text-primary shrink-0 transition-colors duration-500 group-hover:bg-primary/10">
                        <Icon className="w-5 h-5" strokeWidth={0.5} />
                      </div>
                      <div className="pt-1">
                        <h3 className="font-serif text-2xl text-foreground mb-2">
                          {step.title}
                        </h3>
                        <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
                          {step.desc}
                        </p>
                      </div>
                    </div>;
              })}
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight mb-8">
              Zarif Bir Değişim, <br className="hidden md:block" />
              <span className="text-primary/80 italic">Doğal Sonuçlar.</span>
            </h2>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-12 font-light max-w-2xl">
              Modern teknikler ve kişiselleştirilmiş yaklaşımımızla, kendi güzelliğinizi en doğal haliyle ön plana çıkarıyoruz. Her adımda sizin konforunuz, güvenliğiniz ve memnuniyetiniz birincil önceliğimizdir.
            </p>

            <ul className="space-y-5 mb-14">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-center gap-4 text-foreground/90 text-lg font-light">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-primary/10 text-primary shrink-0">
                    <Check className="w-3.5 h-3.5" strokeWidth={1.5} />
                  </span>
                  {benefit}
                </li>)}
            </ul>

            <div>
              <Button asChild size="lg" className="rounded-full px-8 h-14 font-serif text-lg tracking-wide hover:scale-105 transition-transform duration-300">
                <Link to="/ContactPage">Randevu Oluştur</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}